//@ts-nocheck
import React from "react";
import styles from "./ReadOnlyText.module.scss";

function ReadOnlyText(props) {
	const { color, fieldInstanceId, fieldTemplate, fromTable } = props;

	return (
		<div key={fieldInstanceId} className={fromTable ? styles.inputWrapperTable : styles.inputWrapper} data-fieldtemplateid={fieldTemplate.id}>
			{!fromTable ? (
				<div className={styles.header_wrapper}>
					<div style={{ color: color.text.primary }} className={styles.header}>
						<div> {fieldTemplate.header}</div>
					</div>
				</div>
			) : (
				<div style={{ minWidth: "max-content", color: color.text.primary }}> {fieldTemplate.header}</div>
			)}
		</div>
	);
}

export default ReadOnlyText;
